"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAmazonImage = exports.getVersionUrl = exports.getCORSSecureUrl = exports.isUrl = void 0;
const dom_utils_1 = require("./dom-utils");
const isUrl = (url) => {
    try {
        new URL(url);
        return true;
    }
    catch (e) {
        return false;
    }
};
exports.isUrl = isUrl;
/**
 * Replaces the URLs with CloudFront (CDN) URLs.
 *
 * This function doesn't attempt to check whether the URL is actually reachable.
 *
 * @param {string} url - The original URL.
 * @param {boolean} [isQa=false] - A flag indicating whether the environment is QA.
 * @returns {string} The new URL.
 */
const getCORSSecureUrl = (url, isQa) => {
    let newUrl = url;
    if (url && typeof url === 'string' && !(0, dom_utils_1.isDataURL)(url)) {
        if (url.match(/.*\/([^/\s]+(fluer)[^/\s]+\/)(.*)/))
            return url.replace('s3.amazonaws.com/', '');
        let path;
        const pathStartsWithSlash = url.match(/^\/.*/);
        if (pathStartsWithSlash)
            path = pathStartsWithSlash[0];
        const pathMatchesDomain = url.match(/.*\/([^/\s]+(inkive|desygner|webrand|photodexia)[^/\s]+\/)(.*)/);
        if (pathMatchesDomain)
            path = pathMatchesDomain[3];
        if (path) {
            if (isQa) {
                newUrl = `https://static.qadesygner.xyz/${path}`;
            }
            else {
                newUrl = `https://static.desygner.com/${path}`;
            }
        }
    }
    return newUrl;
};
exports.getCORSSecureUrl = getCORSSecureUrl;
/**
 * Returns a version-specific URL for an image.
 *
 * This function modifies the input URL to point to a specific version of the image.
 * The version is determined by the `size` parameter. If the image is an SVG, it returns
 * the original URL since SVGs are scalable by nature.
 *
 * @param {string} url - The original URL of the image.
 * @param {ImageVersion} size - The desired image version.
 * @param {boolean} [isQa=false] - A flag indicating whether the environment is QA.
 * @returns {string} The version-specific URL of the image.
 */
const getVersionUrl = (url, size, isQa) => {
    if (!(0, exports.isUrl)(url))
        return url;
    const isImageSvg = url.endsWith('.svg');
    if (isImageSvg) {
        return (0, exports.getCORSSecureUrl)(url, isQa);
    }
    if ((0, exports.isAmazonImage)(url)) {
        let replacement = '';
        const convertFormats = [
            '/thumb/',
            '/mobile/',
            '/tab/',
            '/web/',
            '/largeweb/',
            '/original/',
        ];
        convertFormats.forEach((format) => {
            const position = url.indexOf(format);
            if (position !== -1 && !replacement) {
                replacement = format;
            }
        });
        if (replacement) {
            url = url.replace(replacement, '/' + size + '/');
        }
        else if (url.indexOf('/img/backgrounds/') > -1) {
            convertFormats.forEach((format) => {
                format = '-' + format.replace(/\//g, '') + '.';
                const position = url.indexOf(format);
                if (position !== -1 && !replacement) {
                    replacement = format;
                }
            });
            url = url.replace(replacement, '-' + size + '.');
        }
    }
    const replacedUrl = url.replace('/original/', '/' + size + '/');
    return (0, exports.getCORSSecureUrl)(replacedUrl, isQa);
};
exports.getVersionUrl = getVersionUrl;
/**
 * Checks if a URL points to an AmazonAws image.
 *
 * This function checks if the input URL points to an image hosted on Amazon S3 or on certain static domains.
 * It returns `true` if the URL matches any of the specified patterns, and `false` otherwise.
 *
 * @param {string} url - The URL to check.
 * @returns {boolean} `true` if the URL points to an Amazon image, `false` otherwise.
 */
const isAmazonImage = (url) => {
    if (!url)
        return false;
    return (url.match(/^((http|https):\/\/s3.amazonaws.com)/) !== null ||
        url.indexOf('static.inkive.me') > -1 ||
        url.indexOf('static.inkive.com') > -1 ||
        url.indexOf('static.webrand.com') > -1 ||
        url.indexOf('static.desygner.com') > -1 ||
        url.indexOf('static.photodexia.com') > -1 ||
        url.indexOf('static.makewebrand.xyz') > -1 ||
        url.indexOf('static.makedesygner.xyz') > -1 ||
        url.indexOf('static.buildwebrand.xyz') > -1 ||
        url.indexOf('static.builddesygner.xyz') > -1 ||
        url.indexOf('static.qawebrand.xyz') > -1 ||
        url.indexOf('static.qadesygner.xyz') > -1);
};
exports.isAmazonImage = isAmazonImage;
//# sourceMappingURL=url-utils.js.map